// extracted by mini-css-extract-plugin
export default {"container":"Category_container__qC18z","image":"Category_image__-ecB7","details":"Category_details__7-jzt","price":"Category_price__b3UZA","cart":"Category_cart__vlCYb"};